import { useEffect } from 'react';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { sendSettingsButtonClickedEvent } from 'utils/analytics-events';

interface UseAboutCignaReturn {
  handleGoBack: () => void;
}

export const useAboutCigna = (): UseAboutCignaReturn => {
  const navigate = useNavigate();

  useEffect(() => {
    sendSettingsButtonClickedEvent('settings', 'about company');
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  return {
    handleGoBack,
  };
};
